
export const sentryRelease = 'gosu-party@PROJECT-CPBL-20250113-02'; 

